import React from 'react';
import { Link } from 'react-router-dom';

const ongoing = [
  { label: 'Website management plans', to: '/services/website-management' },
  { label: 'Managed hosting', to: '/services/managed-hosting' },
  { label: 'Business email', to: '/services/business-email' },
  { label: 'Security and monitoring', to: '/services/website-management' },
  { label: 'Technical support retainers', to: '/services/technical-support' }
];

const projects = [
  'Website design and redesign',
  'Migrations',
  'Malware cleanup',
  'Email delivery problems',
  'Emergency recovery'
];

const ServicesCards = () => {
  return (
    <section className="bg-[#EAF1EC] py-24">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
        <div className="flex flex-col bg-[#174C3C] p-10 text-white sm:p-14">
          <div className="mb-6 text-xs font-bold uppercase tracking-[0.2em] text-[#D7B77A]">
            Every month
          </div>
          <h2 className="text-4xl leading-tight text-white sm:text-5xl">
            Keep the website, email, and hosting working.
          </h2>
          <p className="mt-6 text-xl leading-relaxed text-white/75">
            Updates, backups, security, and a person who already knows the setup.
          </p>
          <ul className="mt-10 border-t border-white/20">
            {ongoing.map((item) => (
              <li key={item.label} className="border-b border-white/20">
                <Link
                  to={item.to}
                  className="block py-4 text-lg font-semibold text-white transition-colors hover:text-[#D7B77A]"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <Link
            to="/services"
            className="mt-8 inline-block font-bold text-[#D7B77A] underline decoration-2 underline-offset-4"
          >
            See all ongoing services
          </Link>
        </div>

        <div className="flex flex-col bg-[#FAF8F3] p-10 sm:p-14">
          <div className="mb-6 text-xs font-bold uppercase tracking-[0.2em] text-[#3B7C6D]">
            When something breaks
          </div>
          <h2 className="text-4xl leading-tight sm:text-5xl">
            A defined job, without the runaround.
          </h2>
          <p className="mt-6 text-xl leading-relaxed text-[#17211E]/70">
            One project, a clear owner, and a finish line.
          </p>
          <ul className="mt-10 border-t border-[#17211E]/15">
            {projects.map((item) => (
              <li
                key={item}
                className="border-b border-[#17211E]/15 py-4 text-lg font-semibold text-[#17211E]"
              >
                {item}
              </li>
            ))}
          </ul>
          <Link to="/digital-review" className="home-link mt-8 inline-block">
            Tell us about the project
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesCards;
